import { render, staticRenderFns } from "./UserActionConflictTable.vue?vue&type=template&id=618a8fb8&"
import script from "./UserActionConflictTable.vue?vue&type=script&lang=js&"
export * from "./UserActionConflictTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports